import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutes } from './app.model';
import { DesktopGuard } from './web/desktop.guard';

const routes: Routes = [
  { path: AppRoutes.PWA, loadChildren: () => import('./pwa/pwa.module').then(m => m.PWAModule) },
  {
    path: AppRoutes.DeviceLanding,
    loadChildren: () =>
      import('./alliance-group/device-landing/device-landing.module').then(m => m.DeviceLandingModule),
  },
  { path: '', loadChildren: () => import('./web/web.module').then(m => m.WebModule), canActivate: [DesktopGuard] },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
